import { TriangleAlert } from 'lucide-react'
import { MismatchBanner } from './SurveyInsightsPageStyles'

export interface SurveyInsightsBannersProps {
  hasMismatch: boolean
  isStale: boolean
  aiSummaryResponseCount: number | null
  newResponsesSinceSynth: number
}

/**
 * Two warning-style banners shown above the question grid:
 *  - mismatch: legacy responses pre-date a question edit
 *  - stale:    new responses arrived after the last synthesis
 */
export function SurveyInsightsBanners({
  hasMismatch,
  isStale,
  aiSummaryResponseCount,
  newResponsesSinceSynth,
}: SurveyInsightsBannersProps) {
  return (
    <>
      {hasMismatch && (
        <MismatchBanner>
          <TriangleAlert size={15} style={{ flexShrink: 0, marginTop: 1 }} />
          <span>
            Some responses were collected before the survey questions were edited. Those responses
            may not align with the current question order — mismatched answers are excluded from
            each chart.
          </span>
        </MismatchBanner>
      )}

      {isStale && (
        <MismatchBanner>
          <TriangleAlert size={15} style={{ flexShrink: 0, marginTop: 1 }} />
          <span>
            Findings were generated from {aiSummaryResponseCount} response
            {aiSummaryResponseCount !== 1 ? 's' : ''}; {newResponsesSinceSynth} new response
            {newResponsesSinceSynth !== 1 ? 's have' : ' has'} arrived since. Close the survey again
            to refresh the findings.
          </span>
        </MismatchBanner>
      )}
    </>
  )
}
